
import template from '../../../templates/checkout-flow/calculator.directive.tpl.html';

import app from '../../App';

export function calculatorDirective ($cookies,RouteHelper,PricingHelper,PlansService,SaveQuoteService,AnyQuestionService) {
    
    'ngInject';

    return {
        restrict: 'E',
        scope: {
            data: '=',
            promocodes: '='
        },
        templateUrl: template,
        link: ( scope, element, attrs) => {
            let plans;
            let currentPlan;
            scope.askQuestion={};
            scope.saveQuote={};
            scope.enterprisePricing={};
            scope.questionSended=false;
            scope.isAnnualPlanSelected=scope.data.plan=='annual'?true:false;
            scope.isMonthlyPlanSelected=scope.data.plan=='monthly'?true:false;
            scope.percentageOffLicenseForAnnual=0;
            scope.percentageOffDevicesForAnnual=0;
            scope.saveQuoteSended=false;
            scope.anyQuestionSended=false;
            scope.devices=(scope.data.devices!=scope.data.displays)?parseInt(scope.data.devices):parseInt(scope.data.displays);
            let formatMoney = (n, c, d, t) => {
                var c = isNaN(c = Math.abs(c)) ? 2 : c,
                    d = d == undefined ? "." : d,
                    t = t == undefined ? "," : t,
                    s = n < 0 ? "-" : "",
                    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                    j = (j = i.length) > 3 ? j % 3 : 0;
                return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
            };
            scope.renderToCurrency= (value) => {
                return formatMoney(value,2,'.',',');
            };
            let populatePlans = () => {
                PlansService.getNewBillingPlans().then((response)=> {
                    plans=response.data.Result;
                    getPlan();
                    scope.calculatePlans();
                });
            };
            let getPlan = (displaysQuantity=0)=>{
                if(plans){
                    return PlansService.generatePlanServiceValueObject(plans
                        .sort((a,b) => a.MaxDevices-b.MaxDevices)
                        .filter((value) => value.MaxDevices >= displaysQuantity).shift());
                }
            };
            let initSlider = () => {
                let draggable = document.getElementsByClassName('toggle'),
                    draggableCount = draggable.length,
                    i;
                let toggle;
                let startDrag = (evt) => {
                    evt.changedTouches?evt.clientX=evt.changedTouches[0].clientX:evt;
                    evt.preventDefault();
                    toggle = evt.target;
                    let track = toggle.previousElementSibling,
                        diffX = evt.clientX - toggle.offsetLeft;
                    let moveAlong = (evt) => {
                        evt.changedTouches?evt.clientX=evt.changedTouches[0].clientX:evt;
                        var left = parseInt(evt.clientX - diffX);
                        if (left < 0) {
                            left = 0;
                        }
                        if ( left> track.offsetWidth-32) {
                            left = track.offsetWidth-32
                        }
                        toggle.style.left = left + 'px';
                        let ticks=document.getElementsByClassName("tick-text");
                        let ticksValuesOffsets=Array.prototype.map.call(ticks,(element)=>{ return {value:parseInt(element.innerHTML),offset:element.offsetLeft+element.offsetWidth*0.5};});
                        ticksValuesOffsets.forEach((item,index,arr)=> {
                            let toggleOffset = toggle.offsetLeft + toggle.offsetWidth * 0.5;
                            if(toggleOffset<item.offset && index>=1 && toggleOffset>ticksValuesOffsets[index-1].offset){
                                let currentValue=ticksValuesOffsets[index-1].value+parseInt((ticksValuesOffsets[index].value-ticksValuesOffsets[index-1].value)*(toggleOffset-ticksValuesOffsets[index-1].offset)/(ticksValuesOffsets[index].offset-ticksValuesOffsets[index-1].offset));
                                currentValue=parseInt((parseInt((toggleOffset-ticksValuesOffsets[index-1].offset)/((ticksValuesOffsets[index].offset-ticksValuesOffsets[index-1].offset)/((ticksValuesOffsets[index].value-ticksValuesOffsets[index-1].value)*2)))+1)/2+ticksValuesOffsets[index-1].value);
                                scope.data.displays=currentValue+1;
                                scope.$apply();
                                scope.data.displays=currentValue;
                                scope.$apply();
                            }
                        });
                    };
                    let stopDrag = () => {
                        document.removeEventListener('mousemove', moveAlong);
                        document.removeEventListener('mouseup', stopDrag);
                        document.body.removeEventListener('touchmove', moveAlong);
                        document.body.removeEventListener('touchend', stopDrag);
                        let ticks=document.getElementsByClassName("tick-text");
                        let ticksValuesOffsets=Array.prototype.map.call(ticks,(element)=>{ return {value:parseInt(element.innerHTML),offset:element.offsetLeft+element.offsetWidth*0.5};});
                        ticksValuesOffsets.forEach((item,index,arr)=>{
                            let toggleOffset=toggle.offsetLeft+toggle.offsetWidth*0.5;
                            if(index==0 && toggleOffset<=item.offset){
                                scope.data.displays=item.value+1;
                                scope.$apply();
                                scope.data.displays=item.value;
                                scope.$apply();
                            }
                            if(toggleOffset<item.offset && index>=1 && toggleOffset>ticksValuesOffsets[index-1].offset){
                                let currentValue=ticksValuesOffsets[index-1].value+parseInt((ticksValuesOffsets[index].value-ticksValuesOffsets[index-1].value)*(toggleOffset-ticksValuesOffsets[index-1].offset)/(ticksValuesOffsets[index].offset-ticksValuesOffsets[index-1].offset));
                                currentValue=parseInt((parseInt((toggleOffset-ticksValuesOffsets[index-1].offset)/((ticksValuesOffsets[index].offset-ticksValuesOffsets[index-1].offset)/((ticksValuesOffsets[index].value-ticksValuesOffsets[index-1].value)*2)))+1)/2+ticksValuesOffsets[index-1].value);
                                scope.data.displays=currentValue+1;
                                scope.$apply();
                                scope.data.displays=currentValue;
                                scope.$apply();
                            }
                            if(toggleOffset>item.offset && index==ticks.length-1){
                                scope.data.displays=item.value-1;
                                scope.$apply();
                                scope.data.displays=item.value;
                                scope.$apply();
                            }
                        });
                    };

                    document.addEventListener('mouseup', stopDrag);
                    document.addEventListener('mousemove', moveAlong);
                    document.body.addEventListener('touchend', stopDrag);
                    document.body.addEventListener('touchmove', moveAlong);
                    return false;
                };
                if (draggableCount > 0) for (i = 0; i < draggableCount; i += 1) {
                    draggable[i].addEventListener('mousedown', startDrag);
                    draggable[i].addEventListener('touchstart', startDrag);
                }
            };
            let updateSliderPosition = (evt=null) => {
                let currentDisplaysValue=scope.data.displays;
                let toggle=document.getElementsByClassName('toggle')[0];
                let ticks=document.getElementsByClassName("tick-text");
                let ticksValuesOffsets=Array.prototype.map.call(ticks,(element)=>{ return {value:parseInt(element.innerHTML),offset:element.offsetLeft+element.offsetWidth*0.5};});
                if(evt){
                    evt.changedTouches?evt.clientX=evt.changedTouches[0].clientX:evt;
                    evt.preventDefault();
                    toggle = evt.target;
                }
                ticksValuesOffsets.forEach((item,index,arr)=>{
                    ticks[index].setAttribute('selected',false);
                    if(currentDisplaysValue==item.value){
                        toggle.style.left = item.offset-14 + 'px';
                        ticks[index].setAttribute('selected',true);
                    }
                    if(currentDisplaysValue<item.value && index>=1 && currentDisplaysValue>ticksValuesOffsets[index-1].value){
                        toggle.style.left = ticksValuesOffsets[index-1].offset+(ticksValuesOffsets[index].offset-ticksValuesOffsets[index-1].offset)*((currentDisplaysValue-ticksValuesOffsets[index-1].value)/(ticksValuesOffsets[index].value-ticksValuesOffsets[index-1].value))-14 + 'px';
                    }
                });
            };
            scope.calculatePlans = () => {
                $cookies.putObject('calculator',{numberOfLicenses:scope.data.displays,numberOfDevices:scope.data.devices,isAnnual:scope.isAnnualPlanSelected});
                if(plans && scope.data.displays<100) {
                    currentPlan = getPlan(scope.data.displays);
                    scope.isAnnualPlanSelected=scope.data.plan=='annual'?true:false;
                    scope.isMonthlyPlanSelected=scope.data.plan=='monthly'?true:false;
                    scope.monthlyPlanPrice = currentPlan.basePrice+scope.data.displays*currentPlan.pricePerLicense;
                    scope.annualPlanPrice = (currentPlan.basePrice+scope.data.displays*currentPlan.pricePerLicense)*(1-currentPlan.percentageOffLicensesForAnnual);
                    scope.devicePrice = currentPlan.devicePrice;
                    switch (scope.data.plan) {
                        case "annual":
                            scope.annualDeviceDiscount = currentPlan.percentageOffDevicesForAnnual*scope.devices*currentPlan.devicePrice;
                            scope.softwarePlanPricing = scope.annualPlanPrice*12;
                            scope.annualPlanDiscount = 12*(currentPlan.basePrice+scope.data.displays*currentPlan.pricePerLicense)*(currentPlan.percentageOffLicensesForAnnual);
                            break;
                        case "monthly":
                            scope.annualDeviceDiscount = 0;
                            scope.softwarePlanPricing = scope.monthlyPlanPrice;
                            scope.annualPlanDiscount = 0;
                            break;
                    }
                    scope.totalDevicePrice=scope.devicePrice*scope.devices-scope.annualDeviceDiscount;
                    scope.totalPrice = scope.totalDevicePrice+scope.softwarePlanPricing;
                    scope.percentageOffLicenseForAnnual=parseInt(currentPlan.percentageOffLicensesForAnnual*100);
                    scope.percentageOffDevicesForAnnual=parseInt(currentPlan.percentageOffDevicesForAnnual*100);
                }
            };
            scope.setPlanType = (planType)=>{
                scope.data.plan=planType;
                scope.isAnnualPlanSelected=planType=='annual'?true:false;
                scope.isMonthlyPlanSelected=planType=='monthly'?true:false;
                scope.calculatePlans();
            };
            scope.$watch('devices', function(newValue, oldValue) {
                scope.devices=scope.data.devices=newValue;
                scope.calculatePlans();
                updateSliderPosition();
            });
            scope.$watch('data.displays', function(newValue, oldValue) {
                if(newValue!=oldValue) {
                    scope.devices = scope.data.devices = newValue;
                    scope.calculatePlans();
                    updateSliderPosition();
                }
            });
            scope.showSaveQuote=false;
            scope.showSaveQuoteModal = () => {
                scope.showSaveQuote=true;
            };
            scope.hideSaveQuoteModal = () => {
                scope.showSaveQuote=false;
                scope.saveQuoteSended=false;
            };
            scope.saveQuoteSubmit = (form) => {
                let url= 'https://'+location.host+'/checkout/?step=2&displays='+scope.data.displays+'&devices='+scope.data.devices+'&plan='+scope.data.plan;
                if(scope.promocodes && scope.promocodes.length>0){
                    url+='&promocodes=';
                    scope.promocodes.forEach(function(item,index,arr){
                        if(index==0){
                            url+=item.PromoCode;
                        }else{
                            url+=','+item.PromoCode;
                        }
                    });
                }
                SaveQuoteService.saveQuote(scope.saveQuote.name,scope.saveQuote.email,scope.saveQuote.phone,url,scope.data.plan,scope.data.displays,scope.data.devices,scope.softwarePlanPricing).then(
                    (response) => {
                        if(response.data.Success){
                            scope.saveQuoteSended=true;
                        }else{
                            console.log(response);
                        }
                    },
                    (reject) => {
                        console.log(reject);
                    }
                );
            };
            scope.showLearnMore=false;
            scope.showLearnMoreModal = () => {
                scope.showLearnMore=true;
            };
            scope.hideLearnMoreModal = () => {
                scope.showLearnMore=false;
            };
            scope.showAnyQuestions=false;
            scope.showAnyQuestionsModal = () => {
                scope.showAnyQuestions=true;
            };
            scope.hideAnyQuestionsModal = () => {
                scope.showAnyQuestions=false;
                scope.anyQuestionSended=false;
            };
            scope.enterprisePricingSubmit= (form) => {
                let url= 'https://'+location.host+'/checkout/?step=2&displays='+scope.data.displays+'&devices='+scope.data.devices+'&plan='+scope.data.plan;
                if(scope.promocodes && scope.promocodes.length>0){
                    url+='&promocodes=';
                    scope.promocodes.forEach(function(item,index,arr){
                        if(index==0){
                            url+=item.PromoCode;
                        }else{
                            url+=','+item.PromoCode;
                        }
                    });
                }
                AnyQuestionService.sendQuestion(scope.enterprisePricing.name,scope.enterprisePricing.email,scope.enterprisePricing.phone,scope.enterprisePricing.question,url,scope.data.plan,scope.data.displays,scope.data.devices,scope.softwarePlanPricing).then(
                    (response) => {
                        if(response.data.Success){
                            scope.questionSended=true;
                        }else{
                            console.log(response);
                        }
                    },
                    (reject) => {
                        console.log(reject);
                    }
                );
            };
            scope.askQuestionSubmit = (form) => {
                let url= 'https://'+location.host+'/checkout/?step=2&displays='+scope.data.displays+'&devices='+scope.data.devices+'&plan='+scope.data.plan;
                if(scope.promocodes && scope.promocodes.length>0){
                    url+='&promocodes=';
                    scope.promocodes.forEach(function(item,index,arr){
                        if(index==0){
                            url+=item.PromoCode;
                        }else{
                            url+=','+item.PromoCode;
                        }
                    });
                }
                AnyQuestionService.sendQuestion(scope.askQuestion.name,scope.askQuestion.email,scope.askQuestion.phone,scope.askQuestion.question,url,scope.data.plan,scope.data.displays,scope.data.devices,scope.softwarePlanPricing).then(
                    (response) => {
                        if(response.data.Success){
                            scope.anyQuestionSended=true;
                        }else{
                            console.log(response);
                        }
                    },
                    (reject) => {
                        console.log(reject);
                    }
                );
            };
            scope.goToCheckout = () =>{
                var locationUrl='/checkout/?step=2&displays='+scope.data.displays+'&devices='+scope.devices+'&plan='+scope.data.plan;
                location.href = locationUrl;
            };

            initSlider();
            populatePlans();

        }
    };
};

app.directive( 'calculatorDirective', calculatorDirective );



// WEBPACK FOOTER //
// ./src/js/directives/checkout-flow/calculator-directive.js